import React from 'react';
import { BrowserRouter, Route, Routes } from 'react-router-dom';
import { Navbar } from './components/layout/Navbar';
import { Footer } from './components/layout/Footer';
import { ScrollManager } from './components/layout/ScrollManager';
import { Home } from './pages/Home';
import { ComingSoon } from './pages/ComingSoon';
export function App() {
  return <BrowserRouter data-id="element-0" data-mp="3f8ncte49v36g">
      <ScrollManager data-id="element-1" data-mp="2rknnmimlzktz" />
      <div className="min-h-screen w-full bg-canvas" data-id="element-2" data-mp="2rk47n7gir6il">
        <Navbar data-id="element-3" data-mp="2riknh5rqsbbj" />
        <Routes data-id="element-4" data-mp="2mm2luerpkt3f">
          <Route path="/" element={<Home data-id="element-6" data-mp="2mn5a0exnchfn" />} data-id="element-5" data-mp="2mmlsv0ftlx2o" />
          <Route path="/projets" element={<ComingSoon slug="projets" data-id="element-8" data-mp="31agn4l9h89hv" />} data-id="element-7" data-mp="2mnne1xqjvzy4" />
          <Route path="/atelier" element={<ComingSoon slug="atelier" data-id="element-10" data-mp="31ctetq51dy84" />} data-id="element-9" data-mp="31bi9vmzuukff" />
          <Route path="/contact" element={<ComingSoon slug="contact" data-id="element-12" data-mp="2wiffxdr618yp" />} data-id="element-11" data-mp="2wjqhr811w6n6" />
          <Route path="*" element={<Home data-id="element-14" data-mp="28tmfp53igeya" />} data-id="element-13" data-mp="28ufoebm15ej2" />
        </Routes>
        <Footer data-id="element-15" data-mp="28sl3gxardmez" />
      </div>
    </BrowserRouter>;
}